import DOMPurify from "dompurify";

// Centralized sanitization config so all components use the same allow-list
export const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    // Inline
    "b",
    "i",
    "u",
    "em",
    "strong",
    "span",
    "sub",
    "sup",
    "br",
    "code",
    // Block
    "p",
    "div",
    "pre",
    "blockquote",
    "hr",
    // Headings
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    // Lists
    "ul",
    "ol",
    "li",
    // Links
    "a",
    // Tables
    "table",
    "thead",
    "tbody",
    "tr",
    "th",
    "td",
    // Images
    "img",
    // MathJax (needed for proper rendering)
    "mjx-container",
    "mjx-assistive-mml",
    "mjx-math",
    "mjx-mi",
    "mjx-mn",
    "mjx-mrow",
    "mjx-mo",
    "mjx-msup",
    "mjx-mfrac",
    "mjx-msqrt",
    "mjx-mstyle",
    "mjx-mtext",
    "style",
  ],
  ALLOWED_ATTR: [
    "class",
    "rowspan",
    "colspan",
    "align",
    // Links
    "href",
    "target",
    "rel",
    // Images
    "src",
    "alt",
    "title",
    "width",
    "height",
    "loading",
    "decoding",
    // MathJax
    "jax",
    "style",
  ],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|data:image\/)\/?.*/i,
};

// Enforce safer defaults for links and images
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    if (node.getAttribute("target") === "_blank") {
      node.setAttribute("rel", "noopener noreferrer");
    }
  }
  if (node.tagName === "IMG") {
    if (!node.hasAttribute("loading")) node.setAttribute("loading", "lazy");
    if (!node.hasAttribute("decoding")) node.setAttribute("decoding", "async");
  }
});

// Sanitize HTML with the default config; allow overrides per-call if needed
export function sanitizeHTML(html, configOverride = {}) {
  const input = String(html ?? "");
  return DOMPurify.sanitize(input, { ...SANITIZE_CONFIG, ...configOverride });
}
